import _ from 'lodash';
import * as ImpersonateAPI from '../../services/ImpersonateApi';
import userManager from '../../userManager';

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
export const actionCreators = {
	reload: () => {
		userManager.events.addUserSignedOut(() => {
			const keys = Object.keys(localStorage);
			_.each(keys, (x) => {
				if (x.startsWith('oidc.user') || x.endsWith('User_LastActiveTime')) {
					localStorage.removeItem(x);
				}
			});

			window.location.reload();
		});
	},

	endImpersonation: (nextPath?: string) => {
		return ImpersonateAPI.endImpersonateUser()
			.then(() => userManager.removeUser())
			.then(() => {
				if (nextPath != null) {
					window.location.href = nextPath;
				}
			});
	},
};
